import { sweepCircleVsSegmentCapsule } from "./_wallcast";

export default function drawArc(g, app, args) {
  const { origin, settings, pxPerMeter, walls, probeRadiusPx } = args;
  const R = Math.max(0, (settings.radiusM ?? settings.radius ?? 3)) * pxPerMeter;

  const startDeg = Number(settings.startDeg ?? (settings.arcRotationDeg ?? 0));
  const endDeg   = Number(settings.endDeg   ?? (startDeg + (settings.arcSweepDeg ?? 90)));
  const a0 = (Math.min(startDeg, endDeg)) * Math.PI / 180;
  const a1 = (Math.max(startDeg, endDeg)) * Math.PI / 180;

  const lineW = Number.isFinite(settings?.lineWidthPx) ? settings.lineWidthPx : 2;
  const probeR = Number.isFinite(probeRadiusPx) ? probeRadiusPx
                 : Number.isFinite(settings?.probeRadiusPx) ? settings.probeRadiusPx
                 : Math.max(0, lineW * 0.5);

  const N = Math.max(16, Math.floor(Number(settings?.samples) || 144));
  const dA = (a1 - a0) / N;

  try { g.lineStyle({ width: lineW, color: 0x00ffff, alpha: 1 }); }
  catch { g.lineStyle(lineW, 0x00ffff, 1); }

  let first = true;
  for (let i = 0; i <= N; i++) {
    const a = a0 + dA * i;
    const dx = Math.cos(a), dy = Math.sin(a);
    const tx = origin.x + dx * R, ty = origin.y + dy * R;

    let bestT = 1, best = null;
    for (const s of walls || []) {
      const h = sweepCircleVsSegmentCapsule(origin.x, origin.y, tx, ty, probeR, s.x1, s.y1, s.x2, s.y2);
      if (h && h.time < bestT) { bestT = h.time; best = h; }
    }

    const px = best ? origin.x + (tx - origin.x) * best.time : tx;
    const py = best ? origin.y + (ty - origin.y) * best.time : ty;
    const sep = best ? Math.max(0.25, probeR * 0.9) : 0;
    const fx = best ? px - best.nx * sep : px;
    const fy = best ? py - best.ny * sep : py;

    if (first) { g.moveTo(fx, fy); first = false; }
    else g.lineTo(fx, fy);
  }
}
